var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWorkforceBall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 130,
  height: 90,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFE140",
  d: "M22.61 0c.318 5.473 1.924 11.262 5.017 17.296 13.57 26.474 46.22 39.004 72.926 27.988 19.245-7.94 30.151-25.94 29.664-45.284zM60.384 72.906c3.02-5.232 9.73-7.013 14.985-3.979s7.067 9.735 4.046 14.967-9.73 7.014-14.985 3.98c-5.256-3.035-7.067-9.736-4.047-14.968M7.685 17.219c-1.133 1.962-3.649 2.63-5.62 1.492-1.97-1.138-2.65-3.65-1.517-5.612s3.649-2.63 5.62-1.493c1.97 1.138 2.65 3.651 1.517 5.613"
})));
export default SvgWorkforceBall;